(() => {
  const MOBILE_QUERY = '(max-width: 47.999rem)';

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const getFooter = () =>
    document.querySelector('#shopify-section-footer') ||
    document.querySelector('.shopify-section-group-footer-group') ||
    document.querySelector('.footer');

  const getSticky = () => document.querySelector('sticky-add-to-cart.sticky-add-to-cart-container');

  const isFooterVisible = () => {
    const footer = getFooter();
    if (!footer) return false;
    return footer.getBoundingClientRect().top < window.innerHeight;
  };

  let frameId = 0;

  const updateMobileStickyVisibility = (sticky = getSticky()) => {
    if (!sticky || !isMobile()) return;
    sticky.shouldShow = !isFooterVisible();
  };

  const updateDesktopSpacer = (sticky = getSticky()) => {
    if (!sticky?.spacerDiv || isMobile()) return;

    sticky.spacerDiv.classList.remove('is-active');
    sticky.spacerDiv.style.height = '0px';
  };

  const updateStickyLayout = () => {
    const sticky = getSticky();
    const footer = getFooter();

    if (!sticky) return;

    if (isMobile()) {
      sticky.style.bottom = '0';
      updateMobileStickyVisibility(sticky);
      return;
    }

    updateDesktopSpacer(sticky);

    if (!footer) return;

    const footerTop = footer.getBoundingClientRect().top;
    const viewportHeight = window.innerHeight;
    const offset = footerTop < viewportHeight ? Math.max(0, viewportHeight - footerTop) : 0;

    sticky.style.bottom = offset > 0 ? `${offset}px` : '0px';
  };

  const scheduleStickyLayoutUpdate = () => {
    window.cancelAnimationFrame(frameId);
    frameId = window.requestAnimationFrame(updateStickyLayout);
  };

  const bindLayoutObservers = () => {
    if (document.documentElement.dataset.hpStickyAtcLayoutBound === 'true') return;
    document.documentElement.dataset.hpStickyAtcLayoutBound = 'true';

    window.addEventListener('scroll', scheduleStickyLayoutUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyLayoutUpdate, { passive: true });

    const footer = getFooter();
    if (footer) {
      new ResizeObserver(scheduleStickyLayoutUpdate).observe(footer);
    }

    const main = document.getElementById('MainContent');
    if (main) {
      new ResizeObserver(scheduleStickyLayoutUpdate).observe(main);
    }

    document.addEventListener('collapse:open', scheduleStickyLayoutUpdate, true);
    document.addEventListener('collapse:close', scheduleStickyLayoutUpdate, true);

    document.addEventListener(
      'click',
      (event) => {
        if (
          !event.target.closest(
            '[data-hp-faq-toggle], .hp-collection-faq__summary, smooth-collapse [slot="summary"], smooth-collapse #summary'
          )
        ) {
          return;
        }

        scheduleStickyLayoutUpdate();
        [50, 150, 300, 450, 650].forEach((delay) => {
          window.setTimeout(scheduleStickyLayoutUpdate, delay);
        });
      },
      true
    );

    scheduleStickyLayoutUpdate();
  };

  const patchStickyAddToCart = () => {
    const StickyAddToCart = customElements.get('sticky-add-to-cart');
    if (!StickyAddToCart || StickyAddToCart.prototype.__hpBottomPatched) return;

    StickyAddToCart.prototype.__hpBottomPatched = true;

    StickyAddToCart.prototype.handleAddToCartIntersection = function (entry) {
      if (isMobile()) {
        updateMobileStickyVisibility(this);
        return;
      }

      this.shouldShow = !entry.isIntersecting;
    };

    StickyAddToCart.prototype.animateVisibility = function (isInitial) {
      this.animation?.stop?.();
      this.animation = null;

      const show = this.visible;
      const transform = show ? 'translateY(0)' : 'translateY(100%)';

      if (isInitial) {
        this.style.transform = transform;
        this.style.opacity = show ? '1' : '0';
        this.style.visibility = show ? 'visible' : 'hidden';
        updateDesktopSpacer(this);
        scheduleStickyLayoutUpdate();
        return;
      }

      this.style.transition = 'transform 0.25s ease, opacity 0.25s ease, visibility 0.25s ease';
      this.style.transform = transform;
      this.style.opacity = show ? '1' : '0';
      this.style.visibility = show ? 'visible' : 'hidden';
      updateDesktopSpacer(this);
      scheduleStickyLayoutUpdate();
    };

    const originalUpdated = StickyAddToCart.prototype.updated;
    StickyAddToCart.prototype.updated = function (...args) {
      originalUpdated?.call(this, ...args);
      updateDesktopSpacer(this);
      scheduleStickyLayoutUpdate();
    };
  };

  const init = () => {
    patchStickyAddToCart();
    bindLayoutObservers();
    updateStickyLayout();
  };

  if (customElements.get('sticky-add-to-cart')) {
    init();
  } else {
    customElements.whenDefined('sticky-add-to-cart').then(init);
  }

  window.matchMedia(MOBILE_QUERY).addEventListener('change', scheduleStickyLayoutUpdate);
  document.addEventListener('shopify:section:load', scheduleStickyLayoutUpdate);
})();
